import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-list-icon" }
const _hoisted_3 = { class: "contents-list-icon-main" }
const _hoisted_4 = { class: "contents-questions-introduction" }
const _hoisted_5 = { class: "contents-questions-purpose" }
const _hoisted_6 = { class: "contents-questions-purpose-title" }
const _hoisted_7 = { class: "contents-questions-purpose-texts" }
const _hoisted_8 = { class: "contents-questions-purpose-text-1" }
const _hoisted_9 = { class: "contents-questions-purpose-text-3" }
const _hoisted_10 = { class: "contents-questions-purpose-text-3-2" }
const _hoisted_11 = {
  class: "contents-questions-byuse",
  id: "disease_code"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "question-title" }

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { processing, processend } from "@/utils/view";
import { HealthCare } from "@/models/healthCare/healthCare";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";

import CommonMessage from "@/views/base/CommonMessage.vue";

// ---- Types -------------------------------------------------
type Diseases = {
  code: string;
  name: string;
};

// ---- Constant ----------------------------------------------
const componentId = "healthcaredata00-01";
const activeMenu = "health-care";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const diseases = ref<Diseases[]>([]);
const healthCare = new HealthCare();

// ----- Function -----------------------------------------------
// セッションエラーチェック
let sessionErr = ref(false);
let errorDialog = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// 疾患データ取得
const fetchDiseases = async () => {
  await healthCare.getDiseases().then(([model, _response, err]) => {
    if (err) {
      const status = err.error.response.status;
      const decodedMessage = decodeURIComponent(
        err.error?.response?.data?.message
      );
      // セッションエラー
      if (status === 408) sessionErr.value = true;
      errorDialog.open(decodedMessage);
      return;
    } else {
      diseases.value = model.attributes?.result || [];
    }
  });
};

// アンケート一覧ページへ遷移
const goToSurvey = (diseaseCode: string) => {
  if (!diseaseCode) return;

  router.push({
    name: "health-care/survey",
    params: { diseaseCode: diseaseCode },
  });
};

// ---- Vue lifeCycle ----------------------------------------------
onMounted(async () => {
  await fetchDiseases();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { "active-menu": activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("healthcare_msg_title")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contents-list-icon-tri" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                class: "contents-questions-purpose-icon",
                src: "/server/necs/images/sprout_icon.png",
                alt: "healthcare-icon"
              }, null, -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("healthcare_msg_purpose_title")), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("healthcare_msg_purpose_text_1")), 1),
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("healthcare_msg_purpose_text_2")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("healthcare_msg_purpose_text_3")), 1)
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(diseases.value, (disease) => {
              return (_openBlock(), _createElementBlock("li", {
                key: disease.code,
                class: "contents-question-button",
                onClick: ($event: any) => (goToSurvey(disease.code))
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  src: "/server/necs/images/bnr-m-575_or.png",
                  alt: "disease-image"
                }, null, -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(disease.name) + _toDisplayString(_ctx.$t("healthcare_msg_list_here")), 1)
              ], 8, _hoisted_12))
            }), 128))
          ])
        ]),
        _createVNode(Footer, { "scroll-target": componentId })
      ])
    ]),
    (_unref(errorDialog).show)
      ? (_openBlock(), _createBlock(CommonMessage, _mergeProps({ key: 0 }, _unref(errorDialog), {
          onOk: _unref(errorDialog).close,
          onCancel: _unref(errorDialog).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})